import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/public/assets/images/actor-placeholder.png");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/components/Image/Image.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/components/ResultNotFound/ResultNotFound.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/components/TruncatedText/TruncatedText.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSection"] */ "/var/www/cnnew/src/views/MovieDetailsView/components/HeaderSection/HeaderSection.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/views/MovieDetailsView/MovieDetailsActorsView/ActorCard.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/views/MovieDetailsView/MovieDetailsActorsView/MovieDetailsActorsView.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/views/MovieDetailsView/MoviePlayerContext/PlayerContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/views/MovieDetailsView/RelatedMoviesView/RelatedMoviesView.tsx");
